import TableRow from '@mui/material/TableRow'
import * as React from 'react'
import { LeftCell, MiddleCell, RightCell } from '../TreeNode/styled'
import { VerticalLine } from './styled/VerticalLine.styled'

export function VerticalLineTableRow() {
  return (
    <TableRow>
      <LeftCell />
      <MiddleCell>
        <VerticalLine />
      </MiddleCell>
      <RightCell />
    </TableRow>
  )
}
